import { render } from "./PromptCardPreviewModal.vue?vue&type=template&id=55797153"
import script from "./PromptCardPreviewModal.vue?vue&type=script&lang=js"
export * from "./PromptCardPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__